import styled from "styled-components";
import designSystemColors from "../../../../styles";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${designSystemColors.textDark};
`;

export const SwitchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
`;

export const SwitchAndTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-bottom: 5rem;
`;

export const SwitchText = styled.span`
  font-weight: 500;
  color: ${designSystemColors.textDark};
`;
